import React, { useEffect, useRef } from 'react';
import { BackgroundEffectsPlaceholder } from '..';
import './styles.scss';
import { useSelector } from 'react-redux';
import { selectInstitution } from '../../../../../store/features/system';
import BrandedEffectFloatingLogo from '../branded-effect-floating-logo';
import { BrandedVirtualBackground } from '../../../../call/constants';
export function BackgroundEffectsPreview({ video, isApplyingEffect, effect, }) {
    const videoElementRef = useRef(null);
    /**
     * Returns true if the user has the "Branded" background effect applied
     */
    const hasBrandedVirtualBackground = effect === BrandedVirtualBackground;
    const currentInstitution = useSelector(selectInstitution);
    useEffect(() => {
        if (videoElementRef.current) {
            videoElementRef.current.srcObject = video?.srcObject;
        }
    }, [video]);
    return (<div className="background-effects__preview">
      {video ? (<>
          <video ref={videoElementRef} autoPlay muted playsInline/>
          {hasBrandedVirtualBackground && (<BrandedEffectFloatingLogo src={currentInstitution?.logoHorizontal}/>)}
          {isApplyingEffect && (<div className="background-effects__preview__progress-bar"/>)}
        </>) : (<BackgroundEffectsPlaceholder loading={false}/>)}
    </div>);
}
